import { IFirestoreModel, Timestamp } from '@principle-theorem/shared';

export enum KnowledgeBasePushStatus {
  Success = 'success',
  Failure = 'failure',
  Never = 'never',
}

export interface IAIReceptionistKnowledgeBase extends IFirestoreModel {
  // User-entered text fields (map directly to KnowledgeBasePushBody fields)
  practiceDescription?: string;
  generalServices?: string;
  cosmeticServices?: string;
  appointmentsBooking?: string;
  feesPayments?: string;
  parkingAccess?: string;
  additionalInfo?: string;
  publicHolidayNote?: string;
  afterHoursMessage?: string;
  ourTeam?: string; // auto-composed from clinicians but user can override
  // Emergency
  emergencyContact?: string;
  emergencyHours?: IAIReceptionistEmergencyHours;
  // Cancellation
  cancellationPolicy?: string;
  allowsCancellations?: boolean;
  cancellationFeeWindowHours?: number;
  allowsRescheduling?: boolean;
  reschedulingPolicy?: string;
  reschedulingWindowHours?: number;
  sectionQaPairs?: IAIReceptionistSectionQaPairs;
  templateOverrides?: Record<string, IKnowledgeBaseTemplateOverride>;
  customSections?: IAIReceptionistCustomSection[];
  // Push tracking (internal, not sent to API)
  lastPushAt?: Timestamp;
  lastPushStatus?: KnowledgeBasePushStatus;
}

export interface IAIReceptionistEmergencyHours {
  available: boolean;
  contact?: string;
  hours?: string;
}

export interface IAIReceptionistSectionQaPairs {
  generalServices?: IAIReceptionistCustomQA[];
  cosmeticServices?: IAIReceptionistCustomQA[];
  appointments?: IAIReceptionistCustomQA[];
  feesPayments?: IAIReceptionistCustomQA[];
  parkingAccess?: IAIReceptionistCustomQA[];
  ourTeam?: IAIReceptionistCustomQA[];
}

export interface IAIReceptionistCustomSection {
  title: string;
  content: string;
  qa?: IAIReceptionistCustomQA[];
}

export interface IAIReceptionistCustomQA {
  id: string;
  question: string;
  answer: string;
}

export interface IKnowledgeBaseFieldOverride {
  overridden: boolean;
  value: string;
}

export interface IKnowledgeBaseTemplateOverride {
  priceRange?: IKnowledgeBaseFieldOverride; // optional manual price for a treatment
  excludedFromKnowledgeBase?: boolean;
  notes?: IKnowledgeBaseFieldOverride;
}
